import React, { useRef, useEffect, useCallback, useState} from 'react';
import ZCanvas3DComponent from "components/zobject/custom/ZCanvas3DComponent.js";
import * as THREE from "three";
import {connect} from 'react-redux';

const SliderMaterial = ({slotNumber, pad, sliderMaterial, style}) => { 
    let [canvas, setCanvas] = useState(undefined);
    useEffect(() => {
        setCanvas(pad.newSliderRenderer(slotNumber));
        return () => {
            pad.freeSliderRenderer(slotNumber);
        };
    }, []);


    if (canvas) {
        return (
            <ZCanvas3DComponent
              className="slider-canvas" width={style.width} height={style.height} zobject={canvas}/>);
    }
    return '';
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SliderMaterial);
